import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { fetchSiteSettings } from "../../../../store/Actions/UserActions";
import { AuthToken } from "../../../App";
import InputField from "../../../UI/InputField/InputField";
import Button from "../../Button/Button";
import classes from "./Settings.module.css";

const Settings = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchSiteSettings(AuthToken));
  }, []);

  const SettingsHandler = async (e) => {
    // e.preventDefault();

    // if (values.email.length < 1) {
    //   return setError("Please enter to Sign in");
    // }
    // let pattern = new RegExp(
    //   /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
    // );
    // if (!pattern.test(values.email)) {
    //   setError("Please enter valid email address.");
    // }

    // try {
    //   setError("");
    //   await dispatch(Login(values.email));
    //   setValues({ email: "" });
    //   navigate("/confirm-otp");
    // } catch (error) {
    //   if (!navigator.onLine) {
    //     return setError("Please connect to the internet to sign in");
    //   }
    //   navigate("/sign-up");
    // }
  };

  return (
    <div className={classes.settings_wrapper}>
      <form onSubmit={SettingsHandler}>
        <div className={classes.settings_form_wrapper}>
          <div className="row">
            <div className="col-md-6 col-sm-12">
              <div className={classes.input_field_wrapper}>
                <h5>{t("dashboard.settings.formInputsTitles.siteName")}</h5>
                <InputField placeholder="Site Name" />
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className={classes.input_field_wrapper}>
                <h5>{t("dashboard.settings.formInputsTitles.maxItems")}</h5>
                <InputField placeholder="Max Items" />
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className={classes.input_field_wrapper}>
                <h5>
                  {t("dashboard.settings.formInputsTitles.minRentalAmount")}
                </h5>
                <InputField placeholder="Min Rental Amount" />
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className={classes.input_field_wrapper}>
                <h5>
                  {t("dashboard.settings.formInputsTitles.maxRentalAmount")}
                </h5>
                <InputField placeholder="Max Rental Amount" />
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className={classes.input_field_wrapper}>
                <h5>{t("dashboard.settings.formInputsTitles.adminEmail")}</h5>
                <InputField placeholder="Admin Email Address" />
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className={classes.input_field_wrapper}>
                <h5>{t("dashboard.settings.formInputsTitles.maintenance")}</h5>
                <InputField
                  placeholder="Maintenance"
                  toggle={true}
                  checked={true}
                />
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className={classes.input_field_wrapper}>
                <h5>
                  {t("dashboard.settings.formInputsTitles.walletAddress")}
                </h5>
                <InputField placeholder="Enter Wallet Address" />
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className={classes.input_field_wrapper}>
                <h5>{t("dashboard.settings.formInputsTitles.privateKey")}</h5>
                <InputField placeholder="Enter Private Key" />
              </div>
            </div>
            <div className="col-md-12 col-sm-12">
              <div className={classes.input_field_wrapper}>
                <h5>{t("dashboard.settings.formInputsTitles.providerUrl")}</h5>
                <InputField placeholder="Enter Provider URL" fullwidth={true} />
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className={classes.input_field_wrapper}>
                <h5>
                  {t("dashboard.settings.formInputsTitles.PecentagePerOwner")}
                </h5>
                <InputField placeholder="Escrow Fee Percentage" />
              </div>
            </div>
            <div className="col-md-6 col-sm-12">
              <div className={classes.input_field_wrapper}>
                <h5>
                  {t("dashboard.settings.formInputsTitles.PecentagePerPlayer")}
                </h5>
                <InputField placeholder="Escrow Fee Percentage" />
              </div>
            </div>
          </div>
        </div>
        <div className={classes.settings_btn_wrapper}>
          <Button variant="primary">{t("dashboard.settings.btnText")}</Button>
        </div>
      </form>
    </div>
  );
};

export default Settings;
